import React, { useState } from "react";
import { useContext } from "../../../context";
import { numberFormat } from "../../../../../../../../../Utils";
import AdditionalChargesApply from "../../../../../../../../../shared/AdditionalCharges/AdditionalChargesApply";
import { FEE_MODAL_TYPE } from "./config";
import { useMarkNoShow } from "../../../hooks/useMarkNoShow";
import { useSubmit } from "./hooks/useSubmit";
import { useNotificationFlow } from "../../../hooks/useNotificationFlow";

function ModalFee() {
  const {
    modals: {
      fee: { state, isOpen, close },
    },
  } = useContext();

  const markNoShow = useMarkNoShow();
  const notificationFlow = useNotificationFlow();
  const { submit, isSubmitting } = useSubmit();

  const onCancel = submit(async (charge) => {
    if (state.type === FEE_MODAL_TYPE.noShow) {
      await markNoShow.initiate({ charge });
    } else if (state.type === FEE_MODAL_TYPE.cancelation) {
      notificationFlow.start({
        charge,
        isAdditionalProvider: state.isAdditionalProvider,
      });
    }
  });

  return (
    <>
      <div className={isOpen ? "overlay" : ""}></div>
      {isOpen && (
        <div
          id="filterModal"
          role="dialog"
          className="modal fade in displayBlock"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={close}
                >
                  ×
                </button>
                <h4 className="modal-title" id="model_title">
                  Cancellation Fee
                </h4>
              </div>
              <div
                id="errorwindow"
                className="modal-body add-patient-form filter-patient"
              >
                {"There is a cancellation fee of "}
                {numberFormat(state.cancelationFee, "currency")}.
                {" What do you want to do?"}
                <AdditionalChargesApply />
              </div>
              <div className="modal-footer">
                <div className="col-md-12 text-left" id="footer-btn">
                  <button
                    type="button"
                    className="btn btn-success pull-right"
                    onClick={() => onCancel(true)}
                    disabled={isSubmitting}
                  >
                    {"Cancel & Charge"}
                  </button>
                  <button
                    type="button"
                    className="btn logout pull-right m-r-10"
                    onClick={() => onCancel(false)}
                    disabled={isSubmitting}
                  >
                    {"Cancel & Don't Charge"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

ModalFee.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: ({ cancelationFee, type, isAdditionalProvider }) => {
      setState({
        cancelationFee,
        type,
        isAdditionalProvider,
      });
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalFee };
